import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { BuroReportes } from '../Buro/BuroReportes';
import { BuroReporteTabla } from '../Buro/BuroReporteTabla';

/*
 * Buró de Crédito. Navegación por URL para que recargar / atrás conserve el lugar:
 *   /admin/buro               → lista de reportes
 *   /admin/buro?reporte=12    → tabla del reporte 12
 */
export const BuroPage = () => {
  const [params, setParams] = useSearchParams();
  const reporteId = params.get('reporte');

  if (reporteId) {
    return <BuroReporteTabla key={reporteId} id={reporteId} onBack={() => setParams({})} />;
  }
  return <BuroReportes onOpen={(id) => setParams({ reporte: String(id) })} />;
};

export default BuroPage;
